import React from 'react';
import * as Styled from './styled';
import { ParagraphProps } from './types';


const Paragraph: React.FC<ParagraphProps> = ({ children, size, style }) => {
	return (
		<Styled.Paragaraph size={size} style={style}>
			{children}
		</Styled.Paragaraph>
	);
};
Paragraph.defaultProps = {
	size: 'small'
};

export default Paragraph;
